import { googlePlacesApiEndpoint } from '../config'

const GooglePlacesAPIHelper = () => {
  const getCantonByCity = async city => {
    const apiUrl = `${googlePlacesApiEndpoint}/canton/${city}/`
    const result = await window.fetch(apiUrl, {
      // eslint-disable-next-line no-undef
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    return result.json()
  }
  return { getCantonByCity }
}

export default GooglePlacesAPIHelper()
